export default __webpack_public_path__ + "static/media/cssLogo.4e67641b.png";